import { FunctionComponent } from 'react'

import styled, { css } from 'styled-components'

interface PromoLabelProps {
  children: string
  className?: string
}

const StyledPromoLabel = styled.div`
  ${({
    theme: {
      colors: { staticWhite, staticBlack },
      typography: {
        catchword: {
          small2: { bundledCSS: small2CatchwordCSS },
        },
      },
    },
  }) => css`
    display: inline-block;
    ${small2CatchwordCSS};
    color: ${staticBlack};
    background-color: ${staticWhite};
    padding: 0.2em 0.4em 0.12em;
    text-transform: uppercase;
  `}
`

const PromoLabel: FunctionComponent<PromoLabelProps> = ({
  children,
  className,
}) => {
  return <StyledPromoLabel className={className}>{children}</StyledPromoLabel>
}

export default PromoLabel
